/** @type {string} */
export const MINGO_IMG_FALLBACK = '/images/placeholder.svg';

/**
 * via.placeholder.com → local placeholder
 * @param {string} [url]
 */
export function rewriteViaPlaceholderUrl(url) {
  if (!url || typeof url !== 'string' || !url.includes('via.placeholder.com')) return url;
  try {
    return MINGO_IMG_FALLBACK;
  } catch {
    return MINGO_IMG_FALLBACK;
  }
}

/**
 * 로컬 placeholder 이미지 경로.
 * @param {number} w
 * @param {number} h
 * @param {string} [label]
 */
export function imgPlaceholder(w, h, label = 'Mingo') {
  void w;
  void h;
  void label;
  return MINGO_IMG_FALLBACK;
}

/** Use as <img onError={mingoOnImgError} ... /> for broken URLs */
export function mingoOnImgError(e) {
  if (!e?.currentTarget) return;
  e.currentTarget.onerror = null;
  e.currentTarget.src = MINGO_IMG_FALLBACK;
}
